import { apiFetcher } from '~/apis/api-fetcher';

import { SuggestedKeywordsParams, SuggestedKeywordsResponse } from './models';

/** 검색어 추천 조회 */
export const getSuggestedKeywords = (params: SuggestedKeywordsParams, requestInit?: RequestInit) =>
  apiFetcher.get<SuggestedKeywordsResponse>('/api/search/mercari/v1/keywords/suggestions', params, requestInit);
